import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { cabinConfigListEnabled, type CabinCard } from '@/services/cabinConfig';
import CabinPickerSheet from '../components/CabinPickerSheet';
import styles from './CabinTab.module.css';

const CABINS = [
  { id: 'collaboration', name: '战术协调中心' },
  { id: 'strategy',     name: '武器研究学院' },
  { id: 'system',       name: '工程装备车间' },
  { id: 'holographic',  name: '信息监控中心' },
  { id: 'finance',      name: '资源规划中心' },
  { id: 'personal',     name: '知识索引仓库' },
  { id: 'lifesupport',  name: '生命维持中心' },
];

function CabinTab() {
  const navigate = useNavigate();
  const [cabinCards, setCabinCards] = useState<Record<string, CabinCard[]>>({});
  const [loading, setLoading] = useState(true);
  const [selectedCabin, setSelectedCabin] = useState('');
  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    cabinConfigListEnabled()
      .then((cards) => {
        const grouped: Record<string, CabinCard[]> = {};
        cards.forEach((card) => {
          if (!grouped[card.cabinId]) grouped[card.cabinId] = [];
          grouped[card.cabinId].push(card);
        });
        setCabinCards(grouped);
        const first = CABINS.find((c) => grouped[c.id]?.length > 0);
        if (first) setSelectedCabin(first.id);
      })
      .finally(() => setLoading(false));
  }, []);

  const accessibleCabins = CABINS.filter((c) => cabinCards[c.id]?.length > 0);
  const currentCabin = CABINS.find((c) => c.id === selectedCabin);
  const cards = cabinCards[selectedCabin] ?? [];

  const handleCardClick = (card: CabinCard) => {
    if (!card.url) return;
    if (card.url.startsWith('/')) {
      navigate(card.url);
      return;
    }
    window.open(card.url, '_blank');
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.appTitle}>Aden Cockpit</div>
        <button
          className={styles.cabinSelector}
          onClick={() => accessibleCabins.length > 1 && setPickerOpen(true)}
        >
          <span>{currentCabin?.name ?? '...'}</span>
          {accessibleCabins.length > 1 && (
            <DownOutlined className={styles.selectorArrow} />
          )}
        </button>
      </div>

      <div className={styles.cardList}>
        {loading ? (
          <div className={styles.centered}><Spin /></div>
        ) : cards.length === 0 ? (
          <div className={styles.empty}>您暂未获得本舱室使用权限</div>
        ) : (
          cards.map((card) => (
            <div
              key={card.id}
              className={styles.card}
              onClick={() => handleCardClick(card)}
            >
              <div className={styles.cardName}>{card.name}</div>
              {card.desc && <div className={styles.cardDesc}>{card.desc}</div>}
              {card.url && <div className={styles.cardLink}>→ 点击进入</div>}
            </div>
          ))
        )}
      </div>

      <CabinPickerSheet
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        cabins={accessibleCabins}
        selectedId={selectedCabin}
        onSelect={(id) => { setSelectedCabin(id); setPickerOpen(false); }}
      />
    </div>
  );
}

export default CabinTab;
